import { YhBox } from '@/components/YhBox'
import useNavModel, { RouterParamType } from '@/model/navModel'
import { Tabs } from 'antd'
import React, { useState } from 'react'
import { FormBox } from './FormBox'
import { BaseInfo } from './BaseInfo'
import { Contacts } from './Contacts'
import { InvoiceInfo } from './InvoiceInfo'
import { PurchaseHistory } from './purchaseHistory'
import { SupplyDetails } from './supplyDetails'
import {SupplierContract} from './supplierContract'
import { PurchaseInvoice } from './purchaseInvoice'
import { SupplierAccount } from './supplierAccount'

export default () => {
    const { getSelectedNavState } = useNavModel(() => [])
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType)
    return (
        <>
            {detailsInfo && (
                <>
                    <FormBox {...detailsInfo} />

                    <YhBox style={{ padding: ' 0 20px', minHeight: '600px' }}>
                        <Tabs>
                            <Tabs.TabPane tab="基础信息" key="1">
                                <BaseInfo {...detailsInfo} />
                            </Tabs.TabPane>
                            <Tabs.TabPane tab="联系人" key="2">
                                <Contacts {...detailsInfo} />
                            </Tabs.TabPane>
                            <Tabs.TabPane tab="开票信息" key="3">
                                <InvoiceInfo {...detailsInfo} />
                            </Tabs.TabPane>
                            {detailsInfo?.mode === 'edit' && (
                                <>
                                    {' '}
                                    <Tabs.TabPane tab="供应商合同" key="4">
                                        <SupplierContract  {...detailsInfo} />
                                    </Tabs.TabPane>
                                    <Tabs.TabPane tab="供货明细" key="5">
                                        <SupplyDetails {...detailsInfo} />
                                    </Tabs.TabPane>
                                    <Tabs.TabPane tab="采购账单" key="6">
                                        <PurchaseInvoice {...detailsInfo} />
                                    </Tabs.TabPane>
                                    <Tabs.TabPane tab="采购历史" key="7">
                                        <PurchaseHistory {...detailsInfo} />
                                    </Tabs.TabPane>
                                    <Tabs.TabPane tab="供应商账户" key="8">
                                        <SupplierAccount {...detailsInfo} />
                                    </Tabs.TabPane>
                                </>
                            )}
                        </Tabs>
                    </YhBox>
                </>
            )}
        </>
    )
}
